import React, { Fragment, useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { useLocation } from "react-router-dom";

import { IoIosArrowBack } from "react-icons/io";

import PinLogin from "views/components/auth/login/PinLogin";
import ReinstallAndLogin from "views/components/auth/login/ReinstallAndLogin";
import GeneratePin from "views/components/auth/GeneratePin";

const Login = ({ navigatePage }) => {
	const location = useLocation();

	const [loginType, setLoginType] = useState(null);
	const [activeUser, setActiveUser] = useState(null);

	useEffect(() => {
		if (location && location.state) {
			const { loginType, activeUser } = location.state;

			setLoginType(loginType);
			setActiveUser(activeUser);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		loginType && (
			<Transition
				as={Fragment}
				appear={true}
				show={true}
				enter="transition-opacity duration-500"
				enterFrom="opacity-0"
				enterTo="opacity-100"
				leave="transition-opacity duration-250"
				leaveFrom="opacity-100"
				leaveTo="opacity-0"
			>
				<div className="h-screen flex items-center justify-center">
					<div className="flex w-full items-start justify-center">
						<div className="flex flex-col w-full lg:w-[30%] md:w-[50%] items-center justify-center space-y-14">
							<div className="flex w-full items-center justify-center space-x-2">
								<img
									className="w-16"
									src={`${process.env.PUBLIC_URL}/media/changepin-pastelgreen.png`}
									alt="logo"
								/>
								<div className="flex flex-col items-start justify-start">
									<h1 className={`text-3xl font-bold text-dark-blue`}>
										Daffi<span className="italic">Wallet</span>
									</h1>
									<h1 className={`text-3xl font-bold text-dark-blue`}>Welcome</h1>
									<p className="text-sm font-bold text-dark-blue">Enter your username and password</p>
								</div>
							</div>
							<div className="flex w-full items-center justify-center space-x-2">
								{activeUser?.username && loginType === "local" && (
									<PinLogin user={activeUser} loginType={loginType} navigatePage={navigatePage} />
								)}

								{activeUser?.username &&
									loginType === "daffi" &&
									(activeUser?.password ? (
										<PinLogin user={activeUser} loginType={loginType} navigatePage={navigatePage} />
									) : (
										<GeneratePin username={activeUser.username} loginType={loginType} />
									))}

								{activeUser && activeUser === "reinstallFromDaffiAccount" && loginType === "daffi" && (
									<ReinstallAndLogin navigatePage={navigatePage} username={activeUser} loginType={loginType} />
								)}
							</div>
							<div className="flex w-full items-center justify-center">
								<IoIosArrowBack
									className="text-4xl text-dark-blue cursor-pointer"
									onClick={() => navigatePage(-1)}
								/>
							</div>
						</div>
					</div>
				</div>
			</Transition>
		)
	);
};

export default Login;
